import React from "react";
import { Avatar, Hidden } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  content: {
    fontWeight: "bold"
  },
  avatar: {
    marginLeft: theme.spacing(2),
    width: 36,
    minWidth: 36,
    height: 36
  },
  defaultImage: {
    lineHeight: "36px",
    textAlign: "center",
    background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    color: "white",
    fontWeight: "bold",
    borderRadius: "100%"
  }
}));

function getInitial(name) {
  return name ? name.trim().charAt(0) : "";
}

export default function TopNavAvatar(props) {
  const classes = useStyles();
  const { imageSrc, userFirstName, userLastName, welcomeMessage } = props;
  const userName = userFirstName + " " + userLastName;

  function renderAvatar() {
    if (imageSrc) {
      return (
        <Avatar src={imageSrc} alt={userName} className={classes.avatar} />
      );
    } else {
      return (
        <div className={`${classes.avatar} ${classes.defaultImage}`}>
          <span>{getInitial(userFirstName) + getInitial(userLastName)}</span>
        </div>
      );
    }
  }

  return (
    <>
      <Hidden smDown>{welcomeMessage}</Hidden>
      {renderAvatar()}
    </>
  );
}

TopNavAvatar.propTypes = {
  imageSrc: PropTypes.any,
  userFirstName: PropTypes.string,
  userLastName: PropTypes.string,
  welcomeMessage: PropTypes.node
};
